/** Even an unknown asset ID cannot silently erase a known person or object. */
export function ensureSceneSymbols(symbols, view) {
    const result = new Map(symbols);
    const refs = [...view.actors.map((actor) => ({ id: actor.symbolRef, figure: true })), ...view.actors.flatMap((actor) => actor.propRefs.map((id) => ({ id, figure: false }))), ...view.props.map((prop) => ({ id: prop.symbolRef, figure: false })), ...view.fixtures.map((fixture) => ({ id: fixture.symbolRef, figure: false }))];
    for (const { id, figure } of refs) {
        if (result.has(id))
            continue;
        const source = figure ? symbols.get("core.fig.stand") : symbols.get("core.prop.papers") ?? symbols.get("ink.prop.page");
        if (source === undefined)
            continue;
        result.set(id, { meta: { ...source.meta, id }, markup: source.markup.replaceAll(`id="${source.meta.id}"`, `id="${id}"`) });
    }
    return result;
}
/** Last-resort physical drawing, with no network-dependent image. Cast retains
 * its instance IDs and all placements remain those of the current view. */
export function outlineSymbols(symbols, view) {
    const outline = (id, sprite, pose) => {
        if (!sprite.markup.includes("<image"))
            return sprite;
        const { plate: _plate, illustration: _illustration, ...meta } = sprite.meta;
        const { w, h } = meta.footprint;
        const actor = sprite.meta.illustration?.layer === "actor" || id.includes(".cast.") || id.includes(".fig.");
        const seated = (pose ?? sprite.meta.illustration?.pose) === "sit" || (pose === undefined && /[.-]sit(?:-|$)/.test(id));
        const drawing = actor
            ? seated
                ? `<circle cx="${String(w * .4)}" cy="${String(h * .12)}" r="${String(Math.min(w * .2, h * .075))}"/><path d="M${String(w * .4)} ${String(h * .22)}V${String(h * .62)}H${String(w * .75)}V${String(h * .95)}H${String(w * .95)}M${String(w * .4)} ${String(h * .3)}L${String(w * .6)} ${String(h * .5)}H${String(w * .8)}"/>`
                : `<circle cx="${String(w / 2)}" cy="${String(h * .09)}" r="${String(Math.min(w * .2, h * .075))}"/><path d="M${String(w / 2)} ${String(h * .18)}V${String(h * .6)}M${String(w * .16)} ${String(h * .4)}L${String(w / 2)} ${String(h * .25)}L${String(w * .84)} ${String(h * .4)}M${String(w * .2)} ${String(h)}L${String(w / 2)} ${String(h * .6)}L${String(w * .8)} ${String(h)}"/>`
            : `<rect x="1" y="1" width="${String(Math.max(1, w - 2))}" height="${String(Math.max(1, h - 2))}" rx="2"/>`;
        return { meta: { ...meta, id }, markup: `<symbol id="${id}" viewBox="0 0 ${String(w)} ${String(h)}"><g data-recovery-pose="${seated ? "sit" : "stand"}" fill="none" stroke="currentColor" stroke-width="1.8">${drawing}</g></symbol>` };
    };
    const result = new Map([...symbols].map(([id, sprite]) => [id, outline(id, sprite)]));
    for (const actor of view?.actors ?? []) {
        const id = `${actor.symbolRef}-${actor.pose}`;
        const source = symbols.get(id) ?? symbols.get(actor.symbolRef);
        if (source?.markup.includes("<image") === true)
            result.set(id, outline(id, source, actor.pose));
    }
    return result;
}
//# sourceMappingURL=recovery.js.map